import React from 'react';
import { ExternalLink } from 'lucide-react';
import ProjectCarousel from './ProjectCarousel';

const ProjectsDisplay = ({ projects }) => {
    return (
        <section id="projects" className="py-20 md:py-32 relative">
            <div className="max-w-6xl mx-auto px-4 md:px-8">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <h2 className="text-4xl md:text-6xl font-display mb-4 text-white tracking-wide">
                        My Projects
                    </h2>
                    <p className="text-white/40 max-w-2xl mx-auto text-sm font-mono">
                        some stuff i've built :p
                    </p>
                </div>

                {/* Projects Grid */}
                <div className="grid md:grid-cols-2 gap-5">
                    {projects.map((project, index) => (
                        <div
                            key={index}
                            className="rounded-2xl bg-white/[0.03] border border-white/5 overflow-hidden hover:border-white/10 transition-all duration-300 group"
                        >
                            {/* Project Image */}
                            {project.images && project.images.length > 0 && (
                                <ProjectCarousel images={project.images} projectName={project.name} />
                            )}

                            {/* Project Content */}
                            <div className="p-5 space-y-3">
                                {/* Title */}
                                <h3 className="text-xl font-display text-white tracking-wide">
                                    {project.name}
                                </h3>

                                {/* Description */}
                                <p className="text-white/50 text-sm leading-relaxed">
                                    {project.description}
                                </p>

                                {/* Tech Stack */}
                                <div className="flex flex-wrap gap-1.5">
                                    {project.tech.map((tech, i) => (
                                        <span
                                            key={i}
                                            className="px-2 py-1 rounded text-xs bg-white/5 text-white/50 border border-white/5 font-mono"
                                        >
                                            {tech}
                                        </span>
                                    ))}
                                </div>

                                {/* Link */}
                                <a
                                    href={`https://${project.github}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-1.5 text-white/60 hover:text-white transition-colors text-sm mt-2 font-mono"
                                >
                                    <ExternalLink className="w-3.5 h-3.5" />
                                    <span>View Project</span>
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ProjectsDisplay;
